import * as commonActions from './common'
import * as devActions from './dev'

export default {
    ...commonActions,
    ...devActions
}

